<div class="container">
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          Lufttryck - Mässtensvägen 21
        </h1>
      </div>
    </div>
  </section>
</div>


<nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Lufttryck (hPa)</p>
      <p class="title">
        {{pressureObject?.sensorValue}}
      </p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Datum</p>
      <p class="title">{{$safeNavigationMigration(pressureObject?.sensorReadingDate) | date:'dd/MM HH:mm'}}</p>
    </div>
  </div>
</nav>


<div class="columns is-mobile">
  <div class="column is-10 is-offset-1">
    @if (lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0) {
      <canvas baseChart width="200" height="100" [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
      </canvas>
    }
  </div>
</div>